<template>
    <div style="padding: 20px;">
        <div class="header-tool">
            <input @input="handleSearchInput" class="form-control search-input" />
            <el-button size="mini" @click.native="download"><i class="glyphicon glyphicon-download-alt"></i></el-button>
        </div>

        <t-table
            id="mainTable"
            :data="tableData.data"
            :pageSize="queryTableParams.pageSize"
            :curPage="queryTableParams.pageNum"
            :total="tableData.total"
            @current-change="handleTableCurrentChange"
            @sort-change="handleSortable"
            @size-change="handleTablePageSize"
        >
            <t-table-column label="Gene Symbol" property="symbol" width="6%" sortable>
                <template slot-scope="{ row }">
                    <router-link :to="`/genedetail/${row.id}`">{{ row.symbol }}</router-link>
                </template>
            </t-table-column>
            <t-table-column label="Ensembl ID" property="ensg" width="6%" sortable>
                <template slot-scope="{ row }">
                    <router-link :to="`/genedetail/${row.id}`">{{ row.ensg }}</router-link>
                </template>
            </t-table-column>
            <t-table-column label="Location" property="location" width="10%" sortable>
                <template slot-scope="{ row }">
                    <span>chr{{ row.location }}</span>
                </template>
            </t-table-column>
            <t-table-column label="Gene Type" property="type" width="6%" sortable/>
            <t-table-column label="Synonyms" property="synonyms" width="15%" sortable/>
            <!-- <t-table-column label="#Associated Traits" property="assoTraN" width="6%" /> -->
            <t-table-column
                label="Number of Associated Traits"
                property="associationCount"
                width="4%"
                sortable
            >
                <template slot-scope="{ row }">
                    <span>{{row.traitCount}}</span>
                </template>
            </t-table-column>
        </t-table>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";

export default {
    name: "genes",
    mixins: [table_mix],
    data() {
        return {};
    },

    computed: {
        getTableDataAjaxUrl() {
            return "gene/page";
        },
    },

    created() {
        this.refreshTable();
    },

    methods: {
        download() {
            window.open(`/api/gene/export?keyword=${this.queryTableParams.keyword}&categoryId=${this.queryTableParams.categoryId ? this.queryTableParams.categoryId : ''}`, '_blank')
        },
    },
};
</script>

<style lang="less" scoped>
.header-tool {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.search-input {
    display: inline-block;
    width: 200px;
}
</style>
